class EstimatedDelivery extends HTMLElement {
  static addBusinessDays(fromDate, businessDays) {
    const date = new Date(fromDate);
    date.setHours(12, 0, 0, 0);

    let counted = 0;
    while (counted < businessDays) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6) counted++;
    }

    return date;
  }

  static formatDate(date, format, locale) {
    if (format === 'long') {
      return date.toLocaleDateString(locale, {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
      });
    }

    return date.toLocaleDateString(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }

  static toISODate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  static getFormattedEstimate(totalDays, format, locale) {
    const days = parseInt(totalDays, 10);
    if (!days || days <= 0) return '';

    const deliveryDate = EstimatedDelivery.addBusinessDays(new Date(), days);
    const resolvedLocale = locale || document.documentElement.lang || 'es-ES';
    return EstimatedDelivery.formatDate(deliveryDate, format || 'numeric', resolvedLocale);
  }

  static fillPropertyInputs(root = document) {
    root.querySelectorAll('[data-estimated-delivery-property]').forEach((input) => {
      const formattedDate = EstimatedDelivery.getFormattedEstimate(
        input.dataset.totalDays,
        input.dataset.dateFormat,
        input.dataset.locale
      );

      if (!formattedDate) {
        input.value = '';
        input.disabled = true;
        return;
      }

      input.disabled = false;
      input.value = formattedDate;
    });
  }

  connectedCallback() {
    const totalDays = parseInt(this.dataset.totalDays, 10);
    if (!totalDays || totalDays <= 0) {
      this.hidden = true;
      return;
    }

    const locale = this.dataset.locale || document.documentElement.lang || 'es-ES';
    const format = this.dataset.dateFormat || 'numeric';
    const deliveryDate = EstimatedDelivery.addBusinessDays(new Date(), totalDays);
    const formattedDate = EstimatedDelivery.formatDate(deliveryDate, format, locale);

    const textContainer = this.querySelector('[data-estimated-delivery-text]');
    const dateTarget = this.querySelector('[data-estimated-delivery-date]');

    if (dateTarget) {
      dateTarget.textContent = formattedDate;
      dateTarget.setAttribute('datetime', EstimatedDelivery.toISODate(deliveryDate));
    }

    if (textContainer) {
      const template = this.dataset.textTemplate || '';
      textContainer.innerHTML = template.replace(/\[date\]/g, `<strong>${formattedDate}</strong>`);
    }

    EstimatedDelivery.fillPropertyInputs(document);
    this.hidden = false;
  }
}

if (!customElements.get('estimated-delivery')) {
  customElements.define('estimated-delivery', EstimatedDelivery);
}

const fillEstimatedDeliveryProperties = () => EstimatedDelivery.fillPropertyInputs(document);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', fillEstimatedDeliveryProperties, { once: true });
} else {
  fillEstimatedDeliveryProperties();
}

document.addEventListener('shopify:section:load', fillEstimatedDeliveryProperties);
